import React from 'react';
import { useTranslation } from 'react-i18next';
// import './LegalPages.css';

const TermsOfUse = () => {
  const { t } = useTranslation();

  return (
    <div className="footer-link-page">
      <h1>{t('terms.title')}</h1>
      <p className="last-updated">{t('terms.lastUpdated')}</p>

      <section>
        <h2>{t('terms.introTitle')}</h2>
        <p>{t('terms.intro')}</p>
      </section>

      <section>
        <h2>{t('terms.eligibilityTitle')}</h2>
        <p>{t('terms.eligibility')}</p>
      </section>

      <section>
        <h2>{t('terms.contentTitle')}</h2>
        <p>{t('terms.content')}</p>
      </section>

      <section>
        <h2>{t('terms.usageTitle')}</h2>
        <p>{t('terms.usage')}</p>
      </section>

      <section>
        <h2>{t('terms.paymentsTitle')}</h2>
        <p>{t('terms.payments')}</p>
      </section>

      <section>
        <h2>{t('terms.terminationTitle')}</h2>
        <p>{t('terms.termination')}</p>
      </section>

      <section>
        <h2>{t('terms.intellectualTitle')}</h2>
        <p>{t('terms.intellectual')}</p>
      </section>

      <section>
        <h2>{t('terms.disclaimerTitle')}</h2>
        <p>{t('terms.disclaimer')}</p>
      </section>

      <section>
        <h2>{t('terms.changesTitle')}</h2>
        <p>{t('terms.changes')}</p>
      </section>

      <section>
        <h2>{t('terms.contactTitle')}</h2>
        <p>{t('terms.contact')}</p>
      </section>
    </div>
  );
};

export default TermsOfUse;
